import { SectionSwapModel } from '../../swap/models/course_section_swap_model';
import { UnscheduledSectionServant } from '../../views/unscheduled_sections/servants/unscheduled_section_servant';
import { SectionDetailsModel } from '../../components/section_details/models/section_detail_model';
import { ISectionsDatasource } from '../../views/sections/datasources/sections_datasource';
import { RegisterSectionFilters } from '../../views/course_scheduler/filters/register_sections_filters';
import { IRegisterSectionsDatasource } from '../../views/course_scheduler/datasources/register_sections_datasource';
import { Query } from 'utility-ts-orm';
import { ISectionRegistrationAttributesDatasource } from '../datasources/section_registration_attributes_datasource';
import {
  SectionRegistrationAttribute,
  SectionRegistrationAttributes
} from '../builders/section_registraion_attributes_builder';
import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { RegistrationAttributesFacade } from '../facades/registration_attributes_facade';

interface ISectionRegistrationAttributesQueryResult {
  id: SectionRegistrationAttribute['id'];
  attributes: {
    properties: SectionRegistrationAttributes['attributes'];
  };
}
export class SectionRegistrationAttributesQuery implements IQuery {
  private _result: Record<SectionRegistrationAttribute['id'], ISectionRegistrationAttributesQueryResult>;

  constructor(
    private ngSectionRegistrationAttributesDatasource: ISectionRegistrationAttributesDatasource,
    private ngRegisterSectionsDatasource: IRegisterSectionsDatasource,
    private ngUnscheduledSectionServant: UnscheduledSectionServant,
    private ngSectionsDatasource: ISectionsDatasource,
    private ngRegisterSectionFilters: RegisterSectionFilters,
    private ngSectionDetailsModel: SectionDetailsModel,
    private ngRegistrationAttributesFacade: RegistrationAttributesFacade,
    private ngCourseSectionSwapModel: SectionSwapModel
  ) {
    Query.registerQuery(
      this,
      ngSectionDetailsModel,
      ngCourseSectionSwapModel,
      ngRegisterSectionsDatasource,
      ngSectionRegistrationAttributesDatasource
    );
  }

  get result() {
    return this._result;
  }

  getSectionIdsFromSwapMode() {
    return _4
      .compact(
        _4.map(this.ngCourseSectionSwapModel.read().swap_to_section_ids, (item) =>
          _4.find(this.ngSectionsDatasource.metasource().derived(), { id: item.id })
        )
      )
      .map((section) => section.id);
  }

  run() {
    const sectionRegAttrFeatureEnabled = this.ngRegistrationAttributesFacade.isFeatureEnabled();
    if (!sectionRegAttrFeatureEnabled) {
      const emptyList = {};
      this._result = emptyList;
      return this;
    }

    const selectedSectionIds = this.ngRegisterSectionFilters
      .getScheduledSelectableSections(this.ngRegisterSectionsDatasource.values())
      .filter((section) => section.is_selected && section._isEligibleForRegistration)
      .map((section) => section.id);

    let validSectionIdsForRegAttributes = [...selectedSectionIds];

    const selectedSectionIdForWaitListing = this.ngSectionDetailsModel.read().id;
    const selectedSectionForWaitListing = _4.find(this.ngSectionsDatasource.metasource().derived(), {
      id: selectedSectionIdForWaitListing
    });
    if (selectedSectionForWaitListing) {
      const isSelectedForWaitListingSectionFull =
        this.ngUnscheduledSectionServant.isSectionFull(selectedSectionForWaitListing);
      if (isSelectedForWaitListingSectionFull) {
        validSectionIdsForRegAttributes.push(selectedSectionIdForWaitListing);
      }
    }
    validSectionIdsForRegAttributes = validSectionIdsForRegAttributes.concat(this.getSectionIdsFromSwapMode());
    const attributes = this.ngSectionRegistrationAttributesDatasource
      .values()
      .filter((sectionRegAttr) => validSectionIdsForRegAttributes.includes(sectionRegAttr.id))
      .map((sectionReg) => ({
        id: sectionReg.id,
        attributes: {
          properties: sectionReg.attributes
        }
      }));
    this._result = _4.keyBy(attributes, 'id');
    return this;
  }
}

angular
  .module('capability-ng-scheduler')
  .service('ngSectionRegistrationAttributesQuery', SectionRegistrationAttributesQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_attributes/queries/section_registration_attributes_query.ts